// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".breadcrumb[data-v-b50ef614] {\n  height: 38px;\n  background: white;\n  line-height: 38px;\n  margin-bottom: 16px;\n  padding-left: 32px;\n  font-size: 16px;\n}\n.breadcrumb .breadcrumb-item[data-v-b50ef614] {\n  color: #999999;\n  cursor: pointer;\n}\n.breadcrumb .cole[data-v-b50ef614] {\n  color: #333;\n}", ""]);
// Exports
module.exports = exports;
